import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { AddShiftComponent } from './add-shift/add-shift.component';
import { List } from 'src/app/stores/administrator/list.store';
import { tabs } from 'src/app/dummy/tabs';

@Component({
  selector: 'app-shift',
  templateUrl: './shift.component.html',
  styleUrls: ['./shift.component.scss']
})
export class ShiftComponent implements OnInit {
  tabs = tabs.SHIFT

  constructor(
    private router: Router,
    public store: List,
    public ds: DataService,
    public dialog: MatDialog) { }

  create(event) {
    const dialogRef = this.dialog.open(AddShiftComponent, {
      data: null,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  ngOnInit() {
    this.store.fetchData(this.ds.shiftRef(ref => ref.orderBy("order")))
  }

  ngOnDestroy() {
    this.store.dispost();
  }
}
